import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicHeader, { Footer } from "@/components/PublicHeader";
import { Sections } from "@/pages/CardView";
import { api, imgUrl, formatErr } from "@/lib/api";

export default function ExampleCard() {
  const [card, setCard] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/public/example-card").then(({ data }) => setCard(data)).catch((e) => setErr(formatErr(e)));
  }, []);
  return (
    <div className="min-h-screen" data-testid="example-card-page">
      <PublicHeader />
      <main className="max-w-3xl mx-auto px-5 md:px-10 pt-6">
        <p className="eyebrow mb-3">Example Content Card · read-only</p>
        {err && <p className="muted" data-testid="example-card-error">{err}</p>}
        {card && (
          <>
            <header className="flex items-start gap-4 mb-8">
              <img src={imgUrl(card.muse?.face_reference_url)} alt="" className="w-14 h-14 rounded-full object-cover border border-[#9C4DDC]/50" />
              <div>
                <p className="text-xs muted">{card.muse?.name} · Talk Clip</p>
                <h1 className="quote text-xl sm:text-2xl mt-1" data-testid="example-card-quote">“{card.quote}”</h1>
              </div>
            </header>
            <Sections o={card.output} />
            <div className="panel p-8 text-center mt-10">
              <p className="font-display text-2xl">Make one for your muse.</p>
              <Link to="/signup" className="btn-primary mt-6" data-testid="example-card-start-button">Start free — 3 posts on us</Link>
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
